import { motion } from "framer-motion"

interface Props {
  children: React.ReactNode
  delay?: number
}

export const HandDrawnHighlight = ({ children, delay = 0 }: Props) => {
  return (
    <span className="relative">
      <span className="relative z-10">{children}</span>
      <motion.span 
        className="absolute inset-0 bg-[#ff9632] origin-left"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ 
          duration: 0.5, 
          delay,
          ease: [0.65, 0, 0.35, 1]
        }}
      />
    </span>
  )
} 